import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

require('./ToggleInput.scss');

export default function ToggleInput(props) {
  const { checked, disabled, label, labelId, onChange } = props;
  let labelValue;
  if (label != null) {
    labelValue = label;
  } else if (labelId != null) {
    labelValue = <FormattedMessage id={labelId} />;
  } else {
    labelValue = '';
  }

  return (
    <div
      className={`ToggleInput ${props.disabled ? ' disabled' : ''}
        ${props.className ? props.className : ''}
        ${props.size ? props.size : 'default'}`}
    >
      <h4 className="label">
        { labelValue }
      </h4>
      <button
        className={`toggle clickable ${checked ? 'active' : ''}`}
        onClick={() => onChange(!checked)}
        disabled={disabled}
      >
        <span
          className="indicator"
        />
      </button>
    </div>
  );
}

ToggleInput.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['small']),
  disabled: PropTypes.bool,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string,
  labelId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/common/ToggleInput.jsx